import {combineReducers} from 'redux';

import recordsReducer from './recordsSlice';

const entityKey = 'customers';

const stateReducer = combineReducers({
    records: recordsReducer,
});

export default stateReducer;
